import React, { useContext } from 'react';
import { getNextSteps } from './components/expected-next-steps/steps';
import { ParsedServiceData } from '../../confirmation.types';
import HeaderTop from './components/top';
import ExpectedNextSteps from './components/expected-next-steps';
import HeaderBottom from './components/bottom';
import context from '../../../../hoc/context/product/context';
import { enrollmentContext } from '../../../../hoc/context/enrollment/enrollment-context';
import Section from '../../../../hoc/components/section/section';
export interface ISummary {
	parsedData?: ParsedServiceData[];
}

export const SummaryHeader: React.FC<ISummary> = () => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const steps = getNextSteps(enrollmentCtxt);
	return (
		<Section>
			<HeaderTop
				title={
					enrollmentCtxt.isStatic(ctxt)
						? ctxt.json.pages.confirmation.header.staticTitle
						: ctxt.json.pages.confirmation.header.title
				}
			/>
			<ExpectedNextSteps steps={steps} />
			<HeaderBottom />
		</Section>
	);
};
